/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";

import par from "par";
import config from "../../configs/config.json";
import isEmpty from "is-empty";

/**
 * User Interface elements material-ui
 */

import Button from "@material-ui/1.5.1/Button";

import Dialog from "../shared/Dialog";
import TextField from "@material-ui/1.5.1/TextField";
import MenuItem from "@material-ui/1.5.1/MenuItem";
import Chip from "@material-ui/1.5.1/Chip";
import Avatar from "@material-ui/1.5.1/Avatar";
import FontIcon from "@material-ui/1.5.1/Icon";
import DropDownMenu from "@material-ui/1.5.1/Select";
import Table from "@material-ui/1.5.1/Table";
import TableHeader from "@material-ui/1.5.1/TableHead";
import TableHeaderColumn from "@material-ui/1.5.1/TableCell";
import TableBody from "@material-ui/1.5.1/TableBody";
import TableRow from "@material-ui/1.5.1/TableRow";
import TableRowColumn from "@material-ui/1.5.1/TableCell";

/**
 * User Interface elements Aetonix
 */
import Header from "../shared/Header.js";

import Utility from "../shared/Utility.js";
import Scroll from "../shared/InfiniScroll.jsx";
import SearchTable from "../shared/SearchTable.jsx";
import DatePicker from "../shared/DatePicker";
import  AetonixTheme_mui_1_5_1 from "../shared/AetonixTheme_mui_1.5.1";
const Colors = AetonixTheme_mui_1_5_1.palette;

var styles = {
	icon: {
		fontSize: 20,
		color: Colors.canvas
	},
	avatar: {
		backgroundColor: Colors.primary.dark
	},
	back: {
		backgroundColor: Colors.primary.light,
		color: Colors.primary.main
	},
	backPrimary: {
		backgroundColor: "#E0E0E0"
	},
	avatarPrimary: {
		backgroundColor: "#BCBCBC"
	},
	inputProp: {
		style: {
			color: Colors.primary.main,
		}
	},
};

export default render;

function render() {
	var component = this;
	var state = component.state;
	var localization = state.localization;
	var careplanNoticeList = state.careplanChangeList.all();
	var careplanChanges = !!careplanNoticeList.length;
	var offline = state.connection.get("offline");

	var people = state.people;
	var currentPerson = state.currentPerson;
	var machinegroup = state.machinegroup;
	var rowData = state.wandering.map(par(convertData, localization, people, machinegroup));

	var startDate = state.startDate;
	var endDate = state.endDate;
	var report = state.report;
	var fileName = state.fileName;
	var loadMore = state.more;
	// Search related variables
	var choose_date = localization.get("choose_date");
	var userFilter = state.userFilter;
	var statusFilter = state.statusFilter;
	var dateFilter = state.dateFilter;
	var wanderstatus = state.wanderstatus;
	var filterUser = state.filterUser;
	var closeSearch = state.closeSearch;
	var titleKey = "user_wander_history";

	var headers = [
		{
			name: "user",
			content: localization.get("user_wander_history_user")
		}, {
			name: "status",
			content: localization.get("user_wander_history_status")
		}, {
			name: "time",
			content: localization.get("user_wander_history_time")
		}, {
			name: "location",
			content: localization.get("user_wander_history_location")
		}
	];

	var report_actions = [
		csvReport(component, localization), (
			<Button key={"buttoncancel"}
				onClick={par(hideReport, component)}>
				{localization.get("report_cancel")}
			</Button >
		)
	];

	var date_actions = [
		<Button key={"buttontime"}
			onClick={par(handle_date, component, "time")}>
			{localization.get("search_apply")}
		</Button >,
		<Button key={"buttoncancel"}
			onClick={par(hideSearch, component, "time")}>
			{localization.get("form_submissions_history_cancel")}
		</Button >
	];

	var status_actions = [
		<Button key={"buttonstatus"}
			onClick={par(hideSearch, component, "status")}>
			{localization.get("search_done")}
		</Button >
	];

	if (dataHasChanged(state.wandering, state.previousWandering)) {
		component.state.userMetrics.trackEvent("user-wander-history: view wander data", {
			records: state.wandering.map(w => w._id),
		});
		component.setState({
			previousWandering: state.wandering
		});
	}

	return (
		<div className="flex-vertical flex-1">
			<Header
				careplanChanges={careplanChanges}
				offline={offline}
				currentPerson={currentPerson}
				localization={localization}
				titleKey={titleKey}
			/>
			<div className="flex-horizontal ae-empty">
				{renderReportChip(component)}
				{renderUserFilterChip(component)}
				{renderStatusFilterChip(component)}
				{renderDateFilterChip(component)}
			</div>

			<Scroll loadMore={loadMore}>
				<Table>
					{renderHeader(headers)}
					{renderBody(localization, headers, rowData)}
				</Table>
			</Scroll>

			<Dialog actions={report_actions} open={report} title={localization.get("groupwander_report_title")}>
				<div>
					<DatePicker invalid={choose_date}
						labelStart={localization.get("report_start")}
						labelEnd={localization.get("report_end")}
						startDate={startDate}
						endDate={endDate}
						updateStart={par(updateChanged, component, "startDate")}
						updateEnd={par(updateChanged, component, "endDate")}
					/>
					<TextField fullWidth placeholder={localization.get("report_filename")} inputProps={{"aria-label": localization.get("report_filename")}}  value={fileName} onChange={par(updateFileNameChanged, component)} InputProps={styles.inputProp} />
				</div>
			</Dialog>

			<SearchTable action={par(filterUser, component)} ref="searchDialog" search={state.search}
				localization={localization}
				people={people}
				showing={userFilter}
				onClose={closeSearch}
				title={localization.get("search_panel_title_patient")} />

			<Dialog actions={date_actions} open={dateFilter} title={localization.get("search_time")}>
				<DatePicker invalid={choose_date}
					labelStart={localization.get("report_start")}
					labelEnd={localization.get("report_end")}
					startDate={startDate}
					endDate={endDate}
					updateStart={par(updateChanged, component, "startDate")}
					updateEnd={par(updateChanged, component, "endDate")}
				/>
			</Dialog>

			<Dialog actions={status_actions} open={statusFilter} title={localization.get("search_status")}>
				<DropDownMenu value={wanderstatus} inputProps={{"aria-label": localization.get("drop_down_menu")}}  onChange={par(handle_status, component)}>
					<MenuItem value={"connect"}>{localization.get("search_connect")}</MenuItem>
					<MenuItem value={"disconnect"}>{localization.get("search_disconnect")}</MenuItem>
					<MenuItem value={"acknowledge"}>{localization.get("search_acknowledge")}</MenuItem>
					<MenuItem value={"wander"}>{localization.get("search_wander")}</MenuItem>
					<MenuItem value={"invalid"}>{localization.get("search_invalid")}</MenuItem>
				</DropDownMenu>
			</Dialog>

		</div>
	);
}

function dataHasChanged(records, previousRecords) {
	records = records || [];
	previousRecords = previousRecords || [];
	if (records.length !== previousRecords.length) {
		return true;
	}
	for (var i = 0; i < records.length; i++) {
		if (records[i]._id !== previousRecords[i]._id) {
			return true;
		}
	}
	return false;
}

function renderDateFilterChip(component) {
	var state = component.state;
	var deleteOn = noop();
	var styleavatar = styles.avatarPrimary;
	var styleback = styles.backPrimary;

	if (!!state.startDate && !!state.endDate) {
		deleteOn = par(clearSearch, component, "time");
		styleavatar = styles.avatar;
		styleback = styles.back;
	}
	return (
		<Chip className="ae-icon ae-fonticon"
			onDelete={deleteOn}
			style={styleback}
			onClick={par(showSearch, component, "time")}
			avatar={<Avatar style={styleavatar}>
				<FontIcon className="fa fa-filter fa-2x" style={styles.icon} />
			</Avatar>}
			label={renderFilterLabel(component, "time")}
		/>);
}

function renderStatusFilterChip(component) {
	var state = component.state;
	var deleteOn = noop();
	var styleavatar = styles.avatarPrimary;
	var styleback = styles.backPrimary;

	if (state.wanderstatus) {
		deleteOn = par(clearSearch, component, "status");
		styleavatar = styles.avatar;
		styleback = styles.back;
	}
	return (<Chip className="ae-icon ae-fonticon"
    onDelete={deleteOn}
    style={styleback}
    onClick={par(showSearch, component, "status")}
		avatar={<Avatar style={styleavatar}>
      <FontIcon className="fa fa-filter fa-2x" style={styles.icon} />
    </Avatar>}
		label={renderFilterLabel(component, "status")}
	/>);
}

function renderUserFilterChip(component) {
	var state = component.state;
	var deleteOn = noop();
	var styleavatar = styles.avatarPrimary;
	var styleback = styles.backPrimary;

	if (state.query.length) {
		deleteOn = par(clearSearch, component, "user");
		styleavatar = styles.avatar;
		styleback = styles.back;
	}
	return (
		<Chip className="ae-icon ae-fonticon"
			onDelete={deleteOn}
			style={styleback}
			onClick={par(showSearch, component, "user")}
			avatar={<Avatar style={styleavatar}>
				<FontIcon className="fa fa-filter fa-2x" style={styles.icon} />
			</Avatar>}
			label={renderFilterLabel(component, "user")}
		/>
	);
}

function renderReportChip(component) {
	var state = component.state;
	return (
		<Chip className="ae-icon ae-fonticon"
			style={styles.back}
			onClick={par(showReport, component)}
			avatar={<Avatar style={styles.avatar}>
				<FontIcon className="fa fa-floppy-o fa-2x" style={styles.icon} />
			</Avatar>}
			label={state.localization.get("groupcall_report_button")}
		/>
	);
}

function renderHeader(headers) {
	return (
		<TableHeader>
			<TableRow >
				{headers.map(renderHeaderColumn)}
			</TableRow>
		</TableHeader>
	);
}

function renderHeaderColumn(column) {
	return (
		<TableHeaderColumn key={column.content}>
			{column.content}
		</TableHeaderColumn>
	);
}

function renderBody(localization, headers, rows) {
	return (
		<TableBody>
			{rows.map(par(renderRow, localization, headers))}
		</TableBody>
	);
}

function renderRow(localization, headers, row, index) {
	return (
		<TableRow key={index}>
			{headers.map(par(renderRowColumn, localization, row))}
		</TableRow>
	);
}

function renderRowColumn(localization, row, column, index) {
	if (row.status === localization.get("wander_out_zone")) {
		return (
			<TableRowColumn key={index} style={{
				color: "#E60000"
			}}>
				{row[column.name]}
			</TableRowColumn>
		);
	}
	if (row.status === localization.get("wander_acknowledge")) {
		return (
			<TableRowColumn key={index} style={{
				color: "#9E6600"
			}}>
				{row[column.name]}
			</TableRowColumn>
		);
	}
	if (row.status === localization.get("wander_in_zone")) {
		return (
			<TableRowColumn key={index} style={{
				color: "green"
			}}>
				{row[column.name]}
			</TableRowColumn>
		);
	}
	if (row.status === localization.get("wander_false")) {
		return (
			<TableRowColumn key={index} style={{
				color: "blue"
			}}>
				{row[column.name]}
			</TableRowColumn>
		);
	}
	if (row.status === localization.get("wander_wander")) {
		return (
			<TableRowColumn key={index} style={{
				color: "#9E6600"
			}}>
				{row[column.name]}
			</TableRowColumn>
		);
	}
	return (
		<TableRowColumn key={index}>
			{row[column.name]}
		</TableRowColumn>
	);
}

function convertData(localization, people, machines, record) {

	var zone = "";
	if (record.status === ("disconnect" || "wandering")) {
		zone = localization.get("wander_out_zone");
	} else if (record.status === "acknowledge") {
		zone = localization.get("wander_acknowledge");
	} else if (record.status === "invalid") {
		zone = localization.get("wander_false");
	} else if (record.status === "wander") {
		zone = localization.get("wander_wander");
	} else {
		zone = localization.get("wander_in_zone");
	}
	var bracelet_user = Utility.format_name(people.get(record.who));
	var time_of_event = Utility.timestamp(record.created_at);
	var machine_user = record.location;
	if (!machine_user) machine_user = localization.get("user_wander_history_machine_unknown");

	return {
		"user": bracelet_user,
		"status": zone,
		"time": time_of_event,
		"location": machine_user
	};
}

function csvReport(component, localization) {

	var comp = component.state;
	var start = comp.startDate;
	var end = adjust_date(comp.endDate);
	var filename = comp.fileName;

	if (!filename) filename = localization.get("default_file_wandering");

	var language = comp.currentPerson.get("personal").language;
	var timezone = new Date().getTimezoneOffset();

	var url = config.host +
		"/v2/org/wander/history/report?token=" +
		config.token +
		"&start=" +
		encodeURIComponent(start) +
		"&end=" +
		encodeURIComponent(end) +
		"&filename=" +
		encodeURIComponent(filename) +
		"&language=" +
		encodeURIComponent(language) +
		"&timezone=" +
		encodeURIComponent(timezone);

	return (
		<a
			key={url}
			className="ae-report-save"
			href={url}
			download={filename}
			onClick={() =>
				component.state.userMetrics.trackEvent("user-wander-history: download report", {
					start,
					end,
					filename,
					language,
					timezone
				})
			}
		>
			{localization.get("report_save")}
		</a>
	);
}

function hideReport(component) {
	component.state.userMetrics.trackEvent("user-wander-history: close report popup");
	return (
		component.setState({
			report: false,
		})
	);
}

function showReport(component) {
	component.state.userMetrics.trackEvent("user-wander-history: open report popup");
	return (
		component.setState({
			report: true
		})
	);
}

function updateFileNameChanged(component, event) {
	event.persist();
	var value = event.target.value;
	component.setState({
		fileName: value
	});
}

function updateChanged(component, name, event, date) {
	var value = date;
	if (event) {
		value = event._d;
	}
	var update = {};
	update[name] = value;
	component.setState(update);
}

/**
 * A function to reset a date by 1 day ahead.	Used to adjust the end date
 * on the date selector function because the default value is midnight of the
 * day selected instead of say, 23:59 of the day chosen or midnight of the next
 * day
 * @param	{String} date Date string
 * @return {String}			Date string
 */
function adjust_date(date) {
	if (isEmpty(date)) return "";
	var end = new Date(date);
	end.setDate(end.getDate() + 1);
	return end;
}

function showSearch(component, name) {
	if (name === "user") component.setState({
		userFilter: true
	});
	if (name === "status") component.setState({
		statusFilter: true
	});
	if (name === "time") component.setState({
		dateFilter: true
	});
	const event = {
		"user": "user-wander-history: open filter by user popup",
		"status": "user-wander-history: open filter by status popup",
		"time": "user-wander-history: open filter by date popup",
	}[name];
	component.state.userMetrics.trackEvent(event);
}

function hideSearch(component, name) {
	if (name === "user") component.setState({
		userFilter: false
	});
	if (name === "status") component.setState({
		statusFilter: false
	});
	if (name === "time") component.setState({
		dateFilter: false
	});
	const event = {
		"status": "user-wander-history: close filter by status popup",
		"time": "user-wander-history: close filter by date popup",
	}[name] || "user-wander-history: close filter popup";
	component.state.userMetrics.trackEvent(event);
}

function clearSearch(component, name) {
	const eventText = {
		"user": "user-wander-history: clear user filter",
		"status": "user-wander-history: clear status filter",
		"time": "user-wander-history: clear date filter",
	}[name] || "user-wander-history: clear filter";
	component.state.userMetrics.trackEvent(eventText);

	var clear = component.state.filterClear;
	if (name === "user") {
		component.setState({
			query: []
		});
		return clear("user");
	}
	if (name === "status") {
		component.setState({
			wanderstatus: ""
		});
		return clear("status");
	}
	if (name === "time") {
		component.setState({
			startDate: "",
			endDate: new Date()
		});
		return clear("time");
	}
}

function renderFilterLabel(component, name) {
	var state = component.state;
	var localization = state.localization;
	if (name === "time") {
		var start = state.startDate;
		var end = state.endDate;
		if (!start || !end) return localization.get("search_time");
		start = shortDate(start);
		end = shortDate(end);
		const label = start + " - " + end;
		return label;
	}
	if (name === "user") {
		var length = state.query.length;
		if (!length) return (localization.get("search_patient"));
		const label = localization.get("search_patient") + " (" + length + ")";
		return label;
	}
	if (name === "status") {
		var status = state.wanderstatus;
		if (!status) return localization.get("search_status");
		const label = localization.get("search_status_value")[status];
		return label;
	}
}

function shortDate(date) {
	var day = date.getDate();
	var month = date.getMonth() + 1;
	var year = date.getFullYear();
	return (day + "/" + month + "/" + year);

}

function handle_status(component, e) {
	e.persist();
	var value = e.target.value;
	component.setState({
		wanderstatus: value
	});
	hideSearch(component, "status");
	return component.state.filterStatus(value);
}

function handle_date(component, value) {
	var state = component.state;
	hideSearch(component, value);
	var start = state.startDate;
	var end = adjust_date(state.endDate);
	component.state.userMetrics.trackEvent("user-wander-history: filter by date", {
		start,
		end,
	});
	return state.filterDate(start, end);
}

function noop() { }
